// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3R7OH","col":"Table_col__37kk0","fulfillmentStatus":"Table_fulfillmentStatus__2I1Yr","emailCol":"Table_emailCol__3pvtX"};